$(document).ready(function () {
  // GSAP
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

  ScrollSmoother.create({
    wrapper: '#smooth-wrapper',
    content: '#smooth-content',
    smooth: 0.3,
    effects: true,
    smoothTouch: 0,
    normalizeScroll: false,
  })

  // Fly-direct pin
  ScrollTrigger.create({
    trigger: '.fly-direct-wrapper',
    pin: true,
    start: 'top top',
    end: '+=200',
    pinSpacing: true,
  })

  // Universal data-animation handler
  document.querySelectorAll('[data-animation]').forEach(function (el) {
    var type = el.getAttribute('data-animation')
    var delay = parseFloat(el.getAttribute('data-animation-delay')) || 0

    if (type === 'fadeInUp') {
      // Більш "дорогий" і плавний стартовий стан (глибше зміщення)
      gsap.set(el, { opacity: 0, y: 60 })

      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%', // Раніше спрацьовує, щоб анімація довше "осідала"
        once: true,
        onEnter: function () {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 1.4, // Довга та плавна тривалість (типово для епл/авоардс)
            delay: delay,
            ease: 'expo.out', // Експоненційне затухання — надшвидкий старт і довгий м'який фініш
            clearProps: 'transform' // Очищення заради коректної роботи CSS-ховерів пізніше
          })
        },
      })
    } else if (type === 'textReveal') {
      // Преміум-анімація спеціально для великих заголовків (літери/слова виїжджають знизу через маску)
      if (typeof SplitText !== 'undefined') {
        var split = SplitText.create(el, { type: 'lines, words', linesClass: 'reveal-line-mask' })
        gsap.set(split.lines, { overflow: 'hidden' })
        gsap.set(split.words, { yPercent: 100, opacity: 0 })

        ScrollTrigger.create({
          trigger: el,
          start: 'top 90%',
          once: true,
          onEnter: function () {
            gsap.to(split.words, {
              yPercent: 0,
              opacity: 1,
              duration: 1.3,
              delay: delay,
              stagger: 0.03, // Каскадний старт кожного слова
              ease: 'expo.out',
            })
          },
        })
      }
    }
  })

  // Steps padding
  function setStepsPadding() {
    var stepEl = document.querySelector('.step--1')
    if (!stepEl) return
    var padding = (window.innerWidth - stepEl.offsetWidth) / 2
    document
      .querySelector('.steps')
      .style.setProperty('--steps-padding-left', padding + 'px')
  }

  setStepsPadding()
  $(window).on('resize', setStepsPadding)

  // Experience text reveal
  var experienceHeading = document.querySelector('.experience .h2')
  if (experienceHeading) {
    var split = SplitText.create(experienceHeading, { type: 'chars' })

    gsap.fromTo(
      split.chars,
      { color: '#B9BFCA' },
      {
        color: '#080808',
        stagger: 0.03,
        scrollTrigger: {
          trigger: '.experience',
          start: 'top 25%',
          end: 'center center',
          scrub: true,
        },
      },
    )
  }

  // Rotate experience triangle markers clockwise
  gsap.to('.experience__dec--1 path[fill="#080808"]', {
    rotation: 360,
    duration: 30,
    repeat: -1,
    ease: 'none',
    svgOrigin: '382 370',
  })

  // Explore: image navigation by cursor position
  document.querySelectorAll('.explore-item__visual').forEach(function (visual) {
    var images = visual.querySelectorAll('.explore-item__illustration')
    if (images.length === 0) return

    var nav = document.createElement('div')
    nav.className = 'explore-item-navigation'

    var dots = []
    images.forEach(function (_, i) {
      var dot = document.createElement('div')
      dot.className =
        'explore-item-navigation__item' + (i === 0 ? ' is-active' : '')
      dots.push(dot)
      nav.appendChild(dot)
    })

    visual.appendChild(nav)

    var locked = false

    function setActive(index) {
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index)
      })
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index)
      })
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        locked = true
        setActive(i)
      })
    })

    visual.addEventListener('mousemove', function (e) {
      if (locked) return
      var rect = visual.getBoundingClientRect()
      var x = e.clientX - rect.left
      var index = Math.min(
        Math.floor((x / rect.width) * images.length),
        images.length - 1,
      )
      setActive(index)
    })

    visual.addEventListener('mouseleave', function () {
      if (!locked) setActive(0)
    })
  })

  // Explore: allow manual horizontal scroll inside __body (prevent ScrollSmoother intercept)
  var exploreBody = document.querySelector('.explore__body')
  if (exploreBody) {
    exploreBody.addEventListener(
      'wheel',
      function (e) {
        var maxScrollLeft = exploreBody.scrollWidth - exploreBody.clientWidth
        var atLeft = exploreBody.scrollLeft <= 0
        var atRight = exploreBody.scrollLeft >= maxScrollLeft
        var scrollingLeft = e.deltaY < 0 || e.deltaX < 0
        var scrollingRight = e.deltaY > 0 || e.deltaX > 0

        var isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY)
        if (
          isHorizontal &&
          ((scrollingRight && !atRight) || (scrollingLeft && !atLeft))
        ) {
          e.stopImmediatePropagation()
          e.preventDefault()
          exploreBody.scrollLeft += e.deltaX
        }
      },
      { passive: false, capture: true }, 
    )
  }

  // Explore: whole __in block scrolls up faster (parallax), body fades in
  var exploreIn = document.querySelector('.explore__in')
  if (exploreIn) {
    gsap.to(exploreIn, {
      yPercent: -40,
      ease: 'none',
      scrollTrigger: {
        trigger: '.explore',
        scrub: true,
        start: 'top bottom',
        end: 'bottom top',
      },
    })

    gsap.to('.explore__body', {
      opacity: 1,
      y: 0,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.explore__head',
        scrub: 1,
        start: 'top 75%',
        end: 'top 0%'
      },
    })
  }

  // Welcome: plane flies across, wipes text (no pin — natural scroll)
  var welcomeSection = document.querySelector('.welcome')
  var welcomeIllustration = document.querySelector('.welcome__illustration')
  if (welcomeSection && welcomeIllustration) {
    var welcomeTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.welcome',
        scrub: 1,
        start: 'top 25%',
        end: 'bottom 50%',
      },
    })

    // Plane flies from left to right and exits the screen
    welcomeTl.fromTo(
      '.welcome__illustration',
      { left: '0%', xPercent: -100 },
      { left: '100%', xPercent: 100, ease: 'none', duration: 1 },
    )

    // step--2 clip-path tracks the plane center pixel-perfectly every frame
    var welcomeStep2 = document.querySelector('.welcome__step--2')
    gsap.ticker.add(function () {
      if (!welcomeStep2) return
      var planeRect = welcomeIllustration.getBoundingClientRect()
      var step2Rect = welcomeStep2.getBoundingClientRect()

      var wipeLineAbsoluteX = planeRect.left + planeRect.width * 0.5
      var wipeLineInsideStep2X = wipeLineAbsoluteX - step2Rect.left
      var rightInsetPct = ((step2Rect.width - wipeLineInsideStep2X) / step2Rect.width) * 100

      rightInsetPct = Math.max(0, Math.min(100, rightInsetPct))

      welcomeStep2.style.clipPath =
        'inset(0 ' + rightInsetPct.toFixed(2) + '% 0 0)'
    })
  }

  // History: fade-in, count-up numbers, parallax
  var historySection = document.querySelector('.history')
  if (historySection) {
    // Fade-in cells with stagger
    var historyCells = historySection.querySelectorAll('.history__cell')
    gsap.set(historyCells, { opacity: 0, y: 40 })
    ScrollTrigger.create({
      trigger: '.history',
      start: 'top 80%',
      once: true,
      onEnter: function () {
        gsap.to(historyCells, {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.1,
          ease: 'expo.out',
          clearProps: 'transform',
        })
      },
    })

    // Count-up numbers on viewport enter
    historySection.querySelectorAll('.history__number').forEach(function (el) {
      var rawText = el.textContent.trim()
      var hasComma = rawText.indexOf(',') !== -1
      var target = parseFloat(rawText.replace(/,/g, ''))

      ScrollTrigger.create({
        trigger: el,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          var obj = { val: 0 }
          gsap.to(obj, {
            val: target,
            duration: 2,
            ease: 'power2.out',
            onUpdate: function () {
              var current = Math.round(obj.val)
              el.textContent = hasComma ? current.toLocaleString('en-US') : current
            },
          })
        },
      })
    })

    // Parallax — grid moves up slightly on scroll
    gsap.to('.history__grid', {
      yPercent: -5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.history',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    })
  }

  // Advantages: items appear one by one (each centered), then form centered
  // var advantagesSection = document.querySelector('.advantages')
  // var advantagesIn = document.querySelector('.advantages__in')
  // var advantagesItems = Array.from(
  //   document.querySelectorAll('.advantages__items .h2'),
  // )
  // var advantagesFormEl = document.querySelector('.advantages-form')
  // if (
  //   advantagesSection &&
  //   advantagesIn &&
  //   advantagesItems.length &&
  //   advantagesFormEl
  // ) {
  //   var vh = window.innerHeight
  //   var inRect = advantagesIn.getBoundingClientRect()
  //   var sectionRect = advantagesSection.getBoundingClientRect()
  //   var inOffset = inRect.top - sectionRect.top

  //   function advCenterY(el) {
  //     var r = el.getBoundingClientRect()
  //     return vh / 2 - inOffset - (r.top - inRect.top + r.height / 2)
  //   }

  //   var allTargets = advantagesItems.concat([advantagesFormEl])
  //   var centerYs = allTargets.map(function (el) {
  //     return advCenterY(el)
  //   })

  //   // Hide all items and form, center on first item
  //   gsap.set(advantagesItems, { autoAlpha: 0, force3D: true })
  //   gsap.set(advantagesFormEl, { autoAlpha: 0, force3D: true })
  //   gsap.set(advantagesIn, { y: centerYs[0], force3D: true })

  //   var n = advantagesItems.length
  //   var stepDur = 1 / (n + 2) // equal steps: items + form + hold

  //   var advantagesTl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: '.advantages',
  //       pin: true,
  //       scrub: 3,
  //       end: '+=5000',
  //     },
  //   })

  //   // Scale ratios: active = 1, then shrink by distance
  //   var scales = [1, 0.55, 0.44, 0.33, 0.28]

  //   // Build sequential steps — each step sets ALL items to their correct state
  //   advantagesItems.forEach(function (item, i) {
  //     // Show current item
  //     advantagesTl.to(item, {
  //       autoAlpha: 1,
  //       scale: 1,
  //       duration: stepDur,
  //       ease: 'none',
  //       force3D: true,
  //     })

  //     // Move container
  //     advantagesTl.to(
  //       advantagesIn,
  //       { y: centerYs[i], duration: stepDur, ease: 'none', force3D: true },
  //       '<',
  //     )

  //     // Scale down previous items
  //     for (var j = 0; j < i; j++) {
  //       var distance = i - j
  //       advantagesTl.to(
  //         advantagesItems[j],
  //         {
  //           scale: scales[Math.min(distance, scales.length - 1)],
  //           duration: stepDur,
  //           ease: 'none',
  //           force3D: true,
  //         },
  //         '<',
  //       )
  //     }
  //   })

  //   // Form appears
  //   advantagesTl.to(advantagesFormEl, {
  //     autoAlpha: 1,
  //     duration: stepDur,
  //     ease: 'none',
  //     force3D: true,
  //   })
  //   advantagesTl.to(
  //     advantagesIn,
  //     {
  //       y: centerYs[centerYs.length - 1],
  //       duration: formDur,
  //       ease: 'power3.out',
  //     },
  //     '<',
  //   )

  //   // Hold
  //   advantagesTl.to({}, { duration: holdEnd / totalWeight })
  // }
  // Advantages: parallax — block rises slightly faster than scroll
  gsap.to('.advantages', {
    // yPercent: -10,
    ease: 'none',
    scrollTrigger: {
      trigger: '.advantages',
      scrub: true,
      start: 'top 60%',
      end: 'top top',
    },
  })

  // Advantages: Smooth Center Scroll & Solid Stacking
  const advantagesSection = document.querySelector('.advantages')
  const advantagesIn = document.querySelector('.advantages__in')
  const advantagesItems = gsap.utils.toArray('.advantages__items .h2')
  const advantagesFormEl = document.querySelector('.advantages-form')

  if (
    advantagesSection &&
    advantagesIn &&
    advantagesItems.length &&
    advantagesFormEl
  ) {
    // 1. Для точних розрахунків гарантуємо, що контейнер має position: relative
    gsap.set(advantagesIn, { position: 'relative' })

    // 2. Функція для отримання точної позиції елемента всередині контейнера
    const getRelativeOffset = (el) => {
      let offset = 0
      let current = el
      while (current && current !== advantagesIn) {
        offset += current.offsetTop
        current = current.offsetParent
      }
      return offset
    }

    const vh = window.innerHeight
    const offsets = advantagesItems.map(getRelativeOffset)
    const itemHeights = advantagesItems.map((item) => item.offsetHeight)

    // 3. Розраховуємо Y-координату контейнера, щоб кожен елемент був по центру екрану
    const itemCenters = advantagesItems.map((item, index) => {
      return vh / 2 - offsets[index] - item.offsetHeight / 2
    })

    // Налаштування "стопки"
    // Пропорції взяті відповідно до розмірів шрифтів: 72px (1) -> 40px (0.55) -> 32px (0.44) -> 24px (0.33) -> 20px (0.28)
    const stackScales = [1, 0.55, 0.44, 0.33, 0.28]

    const specialRequest = document.querySelector('.special-request')

    // 4. Початковий стан
    // Всі майбутні елементи спочатку маленькі і невидимі (opacity: 0)
    gsap.set(advantagesItems, {
      scale: 0.4,
      opacity: 0,
      transformOrigin: 'top center', // Змінив на top center для легшого математичного контролю відступів
      force3D: true,
    })
    // Перший елемент - активний (по центру, великий, повністю видимий), АЛЕ весь контейнер поки прихований
    gsap.set(advantagesItems[0], { scale: 1, opacity: 1 })
    // Центруємо контейнер по першому елементу
    gsap.set(advantagesIn, { y: itemCenters[0], opacity: 0 }) // Приховуємо контейнер .advantages__in
    if (specialRequest) {
      gsap.set(specialRequest, { opacity: 1 }) // Показуємо .special-request
    }
    // Ховаємо форму
    gsap.set(advantagesFormEl, { autoAlpha: 0, scale: 0.95 })

    // Блокуємо :after (фонове зображення) на старті. Додаємо клас, який ховає ::after
    advantagesSection.classList.add('advantages--hide-bg')

    // 5. Головний таймлайн — scrub + directional snap
    let totalSteps = advantagesItems.length + 2
    var lastAdvProgress = 0
    const advantagesTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.advantages',
        pin: true,
        scrub: 0.3,
        start: 'center center',
        end: '+=' + (totalSteps * 500),
        snap: {
          snapTo: function (progress, self) {
            // Збираємо реальні позиції лейблів як progress values (0-1)
            var totalDur = advantagesTl.duration()
            var labels = advantagesTl.labels
            var points = []
            for (var key in labels) {
              points.push(labels[key] / totalDur)
            }
            points.sort(function (a, b) { return a - b })

            // Визначаємо напрямок
            var direction = progress >= lastAdvProgress ? 1 : -1
            lastAdvProgress = progress

            // Знаходимо найближчий snap point у напрямку скролу
            var best = points[0]
            if (direction > 0) {
              // Скролимо вниз — snap до наступного або поточного (якщо дуже близько)
              for (var i = 0; i < points.length; i++) {
                if (points[i] >= progress - 0.01) {
                  best = points[i]
                  break
                }
              }
            } else {
              // Скролимо вгору — snap до попереднього
              for (var i = points.length - 1; i >= 0; i--) {
                if (points[i] <= progress + 0.01) {
                  best = points[i]
                  break
                }
              }
            }
            return best
          },
          inertia: false,
          duration: { min: 0.3, max: 0.7 },
          delay: 0,
          ease: 'power2.inOut',
        },
      },
    })

    // Спочатку анімація special-request: зникає, потім з'являється advantages__in
    advantagesTl.addLabel('step0')
    if (specialRequest) {
      advantagesTl.to(specialRequest, {
        opacity: 0,
        duration: 0.5,
        ease: 'none',
        onComplete: function () {
          advantagesSection.classList.remove('advantages--hide-bg')
        },
        onReverseComplete: function () {
          advantagesSection.classList.add('advantages--hide-bg')
        },
      })
    }

    // З'являється advantages__in
    advantagesTl.to(advantagesIn, {
      opacity: 1,
      duration: 0.5,
      ease: 'none',
    })
    advantagesTl.addLabel('step1')

    // 6. Будуємо кроки для кожного наступного заголовка
    advantagesItems.forEach((item, i) => {
      if (i === 0) return

      let stepTl = gsap.timeline()

      // Рухаємо весь блок вгору, щоб поточний заголовок став по центру
      stepTl.to(
        advantagesIn,
        {
          y: itemCenters[i],
          duration: 1,
          ease: 'none',
        },
        0,
      )

      // Наступний елемент збільшується і з'являється
      stepTl.to(
        item,
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          ease: 'none',
        },
        0,
      )

      // Попередні елементи зменшуються і формують стопку
      let stackGapPx = 32
      let currentVisualBottom = offsets[i]

      for (let j = i - 1; j >= 0; j--) {
        let distance = i - j
        let targetScale =
          stackScales[Math.min(distance, stackScales.length - 1)]

        let scaledHeight = itemHeights[j] * targetScale
        let targetBottom = currentVisualBottom - stackGapPx
        let targetTop = targetBottom - scaledHeight
        let targetY = targetTop - offsets[j]

        stepTl.to(
          advantagesItems[j],
          {
            scale: targetScale,
            y: targetY,
            opacity: 1,
            duration: 1,
            ease: 'none',
          },
          0,
        )

        currentVisualBottom = targetTop
      }

      advantagesTl.add(stepTl)
      advantagesTl.addLabel('step' + (i + 1))
    })

    // 7. Останній крок: поява форми
    let formTl = gsap.timeline()
    let lastItemCenterY = itemCenters[advantagesItems.length - 1]
    let formTargetY = lastItemCenterY - advantagesFormEl.offsetHeight / 2 - 30

    formTl.to(
      advantagesIn,
      {
        y: formTargetY,
        duration: 1,
        ease: 'none',
      },
      0,
    )

    formTl.to(
      advantagesFormEl,
      {
        autoAlpha: 1,
        scale: 1,
        duration: 1,
        ease: 'none',
      },
      0,
    )

    advantagesTl.add(formTl)
    advantagesTl.addLabel('stepForm')
    advantagesTl.to({}, { duration: 0.2 })
  }

  // Advantages form: step navigation + validation
  var advantagesForm = document.querySelector('.advantages-form__form')
  if (advantagesForm) {
    var formSteps = advantagesForm.querySelectorAll('.advantages-form__step')
    var currentStep = 0

    function showStep(index) {
      formSteps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === index)
      })
      currentStep = index
    }

    // Next button (step 1)
    var nextBtn = formSteps[0].querySelector('.btn-orange')
    if (nextBtn) {
      // Enable/disable next button based on input
      var requiredInput = formSteps[0].querySelector('input[required]')
      if (requiredInput) {
        requiredInput.addEventListener('input', function () {
          var column = requiredInput.closest('.advantages-form__column')
          if (requiredInput.value.trim()) {
            nextBtn.classList.remove('is-disabled')
            column.classList.remove('is-error')
            var existingError = column.querySelector('.inp-group__error')
            if (existingError) existingError.remove()
          } else {
            nextBtn.classList.add('is-disabled')
          }
        })
      }

      nextBtn.addEventListener('click', function () {
        var requiredFields = formSteps[0].querySelectorAll('input[required]')
        var valid = true

        requiredFields.forEach(function (input) {
          var column = input.closest('.advantages-form__column')
          var inpGroup = input.closest('.inp-group')
          var existingError = column.querySelector('.inp-group__error')
          if (existingError) existingError.remove()
          column.classList.remove('is-error')

          if (!input.value.trim()) {
            valid = false
            column.classList.add('is-error')
            var error = document.createElement('span')
            error.className = 'inp-group__error'
            error.textContent = 'This field is required'
            inpGroup.after(error)
          }
        })

        if (valid) showStep(1)
      })
    }

    // Send button (step 2) — validate email
    var sendBtn = formSteps[1].querySelector('.btn-orange')
    if (sendBtn) {
      var emailInput = formSteps[1].querySelector('input[required]')
      if (emailInput) {
        emailInput.addEventListener('input', function () {
          var column = emailInput.closest('.advantages-form__column')
          column.classList.remove('is-error')
          var existingError = column.querySelector('.inp-group__error')
          if (existingError) existingError.remove()
        })
      }

      sendBtn.addEventListener('click', function () {
        var requiredFields = formSteps[1].querySelectorAll('input[required]')
        var valid = true

        requiredFields.forEach(function (input) {
          var column = input.closest('.advantages-form__column')
          var inpGroup = input.closest('.inp-group')
          var existingError = column.querySelector('.inp-group__error')
          if (existingError) existingError.remove()
          column.classList.remove('is-error')

          var value = input.value.trim()
          var errorText = ''

          if (!value) {
            errorText = 'This field is required'
          } else if (
            input.placeholder.toLowerCase().indexOf('email') !== -1 &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ) {
            errorText = 'Please enter a valid email'
          }

          if (errorText) {
            valid = false
            column.classList.add('is-error')
            var error = document.createElement('span')
            error.className = 'inp-group__error'
            error.textContent = errorText
            inpGroup.after(error)
          }
        })

        if (valid) {
          // TODO: submit form
        }
      })
    }

    // Back button (step 2)
    advantagesForm.querySelectorAll('.js-button-back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(currentStep - 1)
      })
    })
  }

  // Check + Step-by-step (scrub + snap)
  var checkSection = document.querySelector('.check')
  var checkMask = document.querySelector('.check__mask')
  var stepByStep = document.querySelector('.step-by-step')
  if (checkSection && checkMask && stepByStep) {
    var vh = window.innerHeight
    var maxR = Math.round(Math.hypot(window.innerWidth, vh) / 2) + 100
    var checkH1 = checkSection.querySelectorAll(
      '.check__in:not(.check__mask .check__in) .h2',
    )
    var checkH2 = checkSection.querySelectorAll('.check__mask .check__in .h2')
    var sbsText = stepByStep.querySelector('.step-by-step__text')
    var sbsItems = stepByStep.querySelector('.step-by-step__items')
    var sbsBgs = stepByStep.querySelectorAll('.step-by-step__bg')
    var sbsItemEls = stepByStep.querySelectorAll('.step-by-step-item')

    gsap.set(sbsBgs, { opacity: 0, scale: 1.05 })
    gsap.set(sbsBgs[0], { opacity: 1, scale: 1 })

    if (sbsItemEls.length) {
      sbsItemEls.forEach(function (el) {
        el.classList.remove('is-active')
      })
      sbsItemEls[0].classList.add('is-active')
      if (
        sbsItems &&
        Math.max(sbsItems.scrollHeight, sbsItems.clientHeight) > 0
      ) {
        var targetTop =
          sbsItemEls[0].offsetTop -
          sbsItems.clientHeight / 2 +
          sbsItemEls[0].clientHeight / 2
        sbsItems.scrollTop = targetTop
      }
      gsap.set(sbsItems, {
        scrollTop: () =>
          sbsItemEls[0].offsetTop -
          sbsItems.clientHeight / 2 +
          sbsItemEls[0].clientHeight / 2,
      })
    }

    // Paused timeline + manual wheel/touch (референс)
    var checkTl = gsap.timeline({ paused: true })

    checkTl.addLabel('circleStart')
    checkTl.to(checkMask, { clipPath: 'circle(' + maxR + 'px at 50% 50%)', duration: 0.25, ease: 'none' })
    checkTl.addLabel('circleExpanded')
    checkTl.to([checkH1[0], checkH2[0]], { opacity: 0, duration: 0.06 }, '+=0')
    checkTl.to([checkH1[1], checkH2[1]], { opacity: 1, duration: 0.07 }, '+=0')
    checkTl.addLabel('circleEnd')
    checkTl.set(stepByStep, { zIndex: 3 })
    checkTl.to(stepByStep, { opacity: 1, duration: 0.05 })
    checkTl.to([checkH1[1], checkH2[1]], { opacity: 0, duration: 0.04 })
    checkTl.to(sbsText, { opacity: 1, duration: 0.05, ease: 'none' })
    checkTl.set(sbsItems, { visibility: 'visible' })
    checkTl.addLabel('sbsVisible')

    var sbsStepTimes = []
    if (sbsItemEls.length > 0 && sbsBgs.length > 0) {
      checkTl.addLabel('sbsStep0')
      checkTl.to({}, { duration: 0.05 })
      sbsStepTimes.push(checkTl.duration())

      sbsItemEls.forEach(function (el, i) {
        if (i === 0) return
        var targetScrollTop = el.offsetTop - sbsItems.offsetHeight / 2 + el.offsetHeight / 2
        var stepTl = gsap.timeline()
        stepTl.to(sbsItems, { scrollTop: targetScrollTop, duration: 1, ease: 'none' }, 0)
        if (sbsBgs[i - 1]) stepTl.to(sbsBgs[i - 1], { opacity: 0, scale: 1.05, duration: 1, ease: 'none' }, 0)
        if (sbsBgs[i]) stepTl.to(sbsBgs[i], { opacity: 1, scale: 1, duration: 1, ease: 'none' }, 0)
        checkTl.add(stepTl)
        checkTl.addLabel('sbsStep' + i)
        sbsStepTimes.push(checkTl.duration())
        checkTl.to({}, { duration: 0.6 })
      })
    }
    checkTl.to({}, { duration: 0.6 })

    // Active step tracking
    var currentSbsStep = 0
    gsap.ticker.add(function () {
      var time = checkTl.time()
      var newStep = 0
      for (var i = sbsStepTimes.length - 1; i >= 0; i--) {
        var midpoint = i === 0 ? sbsStepTimes[0] : (sbsStepTimes[i - 1] + sbsStepTimes[i]) / 2
        if (time >= midpoint) { newStep = i; break }
      }
      if (newStep !== currentSbsStep) {
        currentSbsStep = newStep
        sbsItemEls.forEach(function (e) { e.classList.remove('is-active') })
        sbsItemEls[newStep].classList.add('is-active')
      }
    })

    // States
    var states = [
      checkTl.labels['circleExpanded'] || 0.25,
      checkTl.labels['circleEnd'] || 0.38,
    ].concat(sbsStepTimes)
    var currentState = -1
    var isAnimating = false
    var isExiting = false

    var checkST = ScrollTrigger.create({
      trigger: '.check',
      pin: true,
      start: 'center center',
      end: '+=' + (states.length * 600),
      onEnter: function () { currentState = -1; isExiting = false; checkTl.time(0) },
      onEnterBack: function () {
        clearAutoAdvance(); isExiting = false; currentState = states.length - 1; isAnimating = true
        gsap.to(checkTl, { time: states[states.length - 1], duration: 0.5, ease: 'power2.out', overwrite: true,
          onComplete: function () { gsap.delayedCall(0.2, function () { isAnimating = false }) }
        })
      },
      onLeaveBack: function () { clearAutoAdvance(); currentState = -1; checkTl.time(0) },
    })

    var autoAdvanceTimer = null
    function clearAutoAdvance() { if (autoAdvanceTimer) { clearTimeout(autoAdvanceTimer); autoAdvanceTimer = null } }

    function goToState(state, isAuto) {
      if (!isAuto) clearAutoAdvance()
      isAnimating = true; currentState = state
      // Довша анімація для circle/text станів, швидша для step-by-step
      var dur = state <= 1 ? 0.8 : 0.5
      gsap.to(checkTl, { time: states[state], duration: dur, ease: 'power2.inOut', overwrite: true,
        onComplete: function () {
          gsap.delayedCall(0.1, function () { isAnimating = false })
          if (isAuto && state === 1) { autoAdvanceTimer = setTimeout(function () { goToState(2, true) }, 3000) }
        }
      })
    }

    // Wheel
    checkSection.addEventListener('wheel', function (e) {
      if (!checkST.isActive || isExiting) return
      e.preventDefault()
      if (currentState === -1) {
        if (e.deltaY > 0) goToState(1, true)
        else { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.start - 100, true) }
        return
      }
      if (isAnimating || Math.abs(e.deltaY) < 10) return
      clearAutoAdvance()
      var direction = e.deltaY > 0 ? 1 : -1
      if (currentState === 1 && direction === -1) { currentState = -1; gsap.to(checkTl, { time: 0, duration: 0.8, ease: 'power2.inOut' }); return }
      var nextState = currentState + direction
      if (nextState >= states.length) { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.end + 100, true); return }
      if (nextState < 0) { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.start - 100, true); return }
      goToState(nextState)
    }, { passive: false })

    // Touch
    var checkTouchStartY = 0
    checkSection.addEventListener('touchstart', function (e) { checkTouchStartY = e.touches[0].clientY }, { passive: true })
    checkSection.addEventListener('touchmove', function (e) { if (checkST.isActive && !isExiting) e.preventDefault() }, { passive: false })
    checkSection.addEventListener('touchend', function (e) {
      if (!checkST.isActive || isExiting || isAnimating) return
      var delta = checkTouchStartY - e.changedTouches[0].clientY
      if (Math.abs(delta) < 20) return
      clearAutoAdvance()
      var direction = delta > 0 ? 1 : -1
      if (currentState === -1 && direction === -1) { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.start - 100, true); return }
      if (currentState === -1 && direction === 1) { goToState(1, true); return }
      if (currentState === 1 && direction === -1) { currentState = -1; gsap.to(checkTl, { time: 0, duration: 0.8, ease: 'power2.inOut' }); return }
      var nextState = currentState + direction
      if (nextState >= states.length) { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.end + 100, true); return }
      if (nextState < 0) { isExiting = true; if (ScrollSmoother.get()) ScrollSmoother.get().scrollTo(checkST.start - 100, true); return }
      goToState(nextState)
    })

  }

  // People slider — awwwards-style transitions
  var $peopleSlider = $('.people__items')
  if ($peopleSlider.length) {
    var peopleTotal = $peopleSlider.find('.people-item').length
    var peopleAnimating = false

    $peopleSlider.slick({
      dots: false,
      infinite: true,
      fade: true,
      speed: 0, // instant switch, GSAP handles the animation
      cssEase: 'linear',
      slidesToShow: 1,
      arrows: false,
    })

    // Rebuild dots in the single footer to match real count
    var $footerDots = $('.people__in > .people-item-footer .people-item-footer__dots')
    $footerDots.empty()
    for (var d = 0; d < peopleTotal; d++) {
      $footerDots.append('<div class="people-item-footer__dot"></div>')
    }

    var $arrowPrev = $('.people__arrow--prev')
    var $arrowNext = $('.people__arrow--next')
    var $slides = $peopleSlider.find('.slick-slide:not(.slick-cloned)')

    // Pre-split all slide descriptions — words for reveal effect
    var peopleSplits = []
    $slides.each(function () {
      var descEl = $(this).find('.people-item-body__description')[0]
      if (descEl) {
        peopleSplits.push(SplitText.create(descEl, { type: 'words' }))
      } else {
        peopleSplits.push(null)
      }
    })

    function getSlidePhoto(index) {
      return (
        $slides.eq(index).find('.people-item-body__photo').attr('src') || ''
      )
    }

    // Helper: get all animatable parts of a slide
    function getSlideEls(index) {
      var slide = $slides.eq(index)
      return {
        slide: slide,
        visual: slide.find('.people-item-body__visual')[0],
        photo: slide.find('.people-item-body__photo')[0],
        name: slide.find('.people-item-head__name')[0],
        details: slide.find('.people-item-head__details')[0],
        split: peopleSplits[index],
      }
    }

    // Set initial state: first slide visible, rest ready for entrance
    $slides.each(function (i) {
      var s = getSlideEls(i)
      if (i === 0) {
        gsap.set(s.photo, { scale: 1 })
        gsap.set(s.visual, { opacity: 1 })
        if (s.split) gsap.set(s.split.words, { opacity: 1, y: 0 })
        gsap.set([s.name, s.details], { opacity: 1, y: 0 })
      } else {
        gsap.set(s.photo, { scale: 1.15 })
        gsap.set(s.visual, { opacity: 0 })
        if (s.split) gsap.set(s.split.words, { opacity: 0, y: 6 })
        gsap.set(s.name, { opacity: 0, y: 20 })
        gsap.set(s.details, { opacity: 0, y: 20 })
      }
    })

    // Single crossfade transition — out and in run in parallel with overlap
    function transitionSlides(fromIndex, toIndex) {
      var from = getSlideEls(fromIndex)
      var to = getSlideEls(toIndex)
      var tl = gsap.timeline()

      // ——— OUT (current slide) ———

      // Words fade out
      if (from.split) {
        tl.to(from.split.words, {
          opacity: 0,
          duration: 0.35,
          ease: 'power2.in',
        }, 0)
      }

      // Photo zoom + parent fade
      tl.to(from.visual, {
        opacity: 0,
        duration: 0.5,
        ease: 'power2.inOut',
      }, 0.05)
      tl.to(from.photo, {
        scale: 0.92,
        duration: 0.5,
        ease: 'power2.inOut',
      }, 0.05)

      // Header + footer fade
      tl.to([from.name, from.details], {
        opacity: 0,
        y: -15,
        duration: 0.4,
        ease: 'power2.inOut',
      }, 0)

      // ——— Switch slick at the crossover point ———
      tl.call(function () {
        $peopleSlider.slick('slickGoTo', toIndex, true)
      }, null, 0.3)

      // ——— IN (new slide) — starts overlapping with out ———
      var inStart = 0.3

      // Reset new slide elements
      tl.set(to.photo, { scale: 1.15 }, inStart)
      tl.set(to.visual, { opacity: 0 }, inStart)
      if (to.split) tl.set(to.split.words, { opacity: 0, y: 6 }, inStart)
      tl.set(to.name, { opacity: 0, y: 20 }, inStart)
      tl.set(to.details, { opacity: 0, y: 20 }, inStart)

      // Photo fade in + slow zoom settle
      tl.to(to.visual, {
        opacity: 1,
        duration: 0.7,
        ease: 'power2.out',
      }, inStart)
      tl.to(to.photo, {
        scale: 1,
        duration: 1.2,
        ease: 'power2.out',
      }, inStart)

      // Name
      tl.to(to.name, {
        opacity: 1,
        y: 0,
        duration: 0.55,
        ease: 'power3.out',
      }, inStart + 0.1)

      // Route details
      tl.to(to.details, {
        opacity: 1,
        y: 0,
        duration: 0.55,
        ease: 'power3.out',
      }, inStart + 0.18)

      // Words reveal — each word fades in with slight rise
      if (to.split) {
        tl.to(to.split.words, {
          opacity: 1,
          y: 0,
          stagger: 0.03,
          duration: 0.5,
          ease: 'power3.out',
        }, inStart + 0.15)
      }

      return tl
    }

    function updatePeopleNav(index) {
      // dots
      $footerDots.find('.people-item-footer__dot').each(function (i) {
        $(this).toggleClass('is-active', i === index)
      })

      // side photo arrows with crossfade
      var prevIndex = (index - 1 + peopleTotal) % peopleTotal
      var nextIndex = (index + 1) % peopleTotal

      gsap.to($arrowPrev, {
        opacity: 0,
        duration: 0.2,
        onComplete: function () {
          $arrowPrev.attr('src', getSlidePhoto(prevIndex))
          gsap.to($arrowPrev, { opacity: 0.5, duration: 0.3 })
        },
      })
      gsap.to($arrowNext, {
        opacity: 0,
        duration: 0.2,
        onComplete: function () {
          $arrowNext.attr('src', getSlidePhoto(nextIndex))
          gsap.to($arrowNext, { opacity: 0.5, duration: 0.3 })
        },
      })
    }

    updatePeopleNav(0)

    // Orchestrate the full transition
    function goToSlide(nextIndex) {
      if (peopleAnimating) return
      var currentIndex = $peopleSlider.slick('slickCurrentSlide')
      if (nextIndex === currentIndex) return

      peopleAnimating = true
      updatePeopleNav(nextIndex)

      var tl = transitionSlides(currentIndex, nextIndex)
      tl.eventCallback('onComplete', function () {
        peopleAnimating = false
      })
    }

    $arrowPrev.on('click', function () {
      var cur = $peopleSlider.slick('slickCurrentSlide')
      goToSlide((cur - 1 + peopleTotal) % peopleTotal)
    })

    $arrowNext.on('click', function () {
      var cur = $peopleSlider.slick('slickCurrentSlide')
      goToSlide((cur + 1) % peopleTotal)
    })

    $(document).on('click', '.people-item-footer__arrow--prev', function () {
      var cur = $peopleSlider.slick('slickCurrentSlide')
      goToSlide((cur - 1 + peopleTotal) % peopleTotal)
    })

    $(document).on('click', '.people-item-footer__arrow--next', function () {
      var cur = $peopleSlider.slick('slickCurrentSlide')
      goToSlide((cur + 1) % peopleTotal)
    })

    $(document).on('click', '.people-item-footer__dot', function () {
      var i = $(this).index()
      if (i < peopleTotal) goToSlide(i)
    })
  }

  // Horizontal scroll (no pin)
  var stepsEl = document.querySelector('.steps')
  if (stepsEl) {
    gsap.fromTo(
      stepsEl,
      { x: 0 },
      {
        x: function () {
          return -(stepsEl.scrollWidth - window.innerWidth)
        },
        ease: 'none',
        scrollTrigger: {
          trigger: '.steps-section',
          pin: false,
          scrub: 1, // трохи швидший відгук (scrub)
          start: window.innerWidth <= 1920 ? 'top 50%' : 'top 80%',
          end: window.innerWidth <= 1920 ? 'bottom 50%' : 'bottom 20%',
          invalidateOnRefresh: true,
        },
      },
    )
  }

  // Lenis smooth scrolling — disabled (too slow)
  // const lenis = new Lenis({
  //   duration: 1.1,
  //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //   smoothWheel: true,
  //   wheelMultiplier: 1,
  //   touchMultiplier: 1.5,
  // })
  // Partners: fade-in + parallax
  var partnersSection = document.querySelector('.partners')
  if (partnersSection) {
    var partnerItems = partnersSection.querySelectorAll('.partners-item')
    gsap.set(partnerItems, { opacity: 0, y: 40 })
    ScrollTrigger.create({
      trigger: '.partners',
      start: 'top 80%',
      once: true,
      onEnter: function () {
        gsap.to(partnerItems, {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.1,
          ease: 'expo.out',
          clearProps: 'transform',
        })
      },
    })

    gsap.to('.partners__body', {
      yPercent: -5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.partners',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    })
  }

  // Blog posts: fade-in + parallax
  var blogSection = document.querySelector('.blog-posts')
  if (blogSection) {
    var blogItems = blogSection.querySelectorAll('.blog-posts-item')
    gsap.set(blogItems, { opacity: 0, y: 40 })
    ScrollTrigger.create({
      trigger: '.blog-posts',
      start: 'top 80%',
      once: true,
      onEnter: function () {
        gsap.to(blogItems, {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.1,
          ease: 'expo.out',
          clearProps: 'transform',
        })
      },
    })

    gsap.to('.blog-posts__items', {
      yPercent: -5,
      ease: 'none',
      scrollTrigger: {
        trigger: '.blog-posts',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      },
    })
  }

  // lenis.on('scroll', ScrollTrigger.update)
  // gsap.ticker.add((time) => {
  //   lenis.raf(time * 1000)
  // })
  // gsap.ticker.lagSmoothing(0)
})
